var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('error-modal',{attrs:{"is-open-modal":_vm.isError,"errors":_vm.errors,"message":_vm.message},on:{"closed":_vm.clearErrors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }